export default __webpack_public_path__ + "static/media/aramex.ce4b4be3.svg";